export type RouteClass = 'auth' | 'meetings' | 'messenger' | 'room' | 'settings' | 'other';

/** Map pathname to a coarse route bucket — never emit raw pathname (PII / token risk). */
export const getRouteClass = (pathname: string): RouteClass => {
  if (pathname.startsWith('/auth')) return 'auth';
  if (pathname.startsWith('/meetings') || pathname.startsWith('/meeting')) return 'meetings';
  if (pathname.startsWith('/messenger') || pathname.startsWith('/chat')) return 'messenger';
  if (pathname.startsWith('/rooms/') || /^\/[^/]+$/.test(pathname)) return 'room';
  if (pathname.startsWith('/settings')) return 'settings';
  return 'other';
};
